// extracted by mini-css-extract-plugin
export default {"welcome__text":"Welcome_welcome__text__-RFcs"};